import { useNavigate } from "react-router-dom";

import EmailRecoveryForm from "@/pages/Profile/ChangePhone/ChangePhoneForm";
import {
    AuthWrapper,
    ForgetPasswordWrapper,
    StyledLink,
} from "@/pages/Profile/ChangePhone/Styled";
import { MainContainer } from "@/shared/layout/Layout";
import { Meta } from "@/shared/seo";

const ChangePhone = () => {
    const navigate = useNavigate();
    return (
        <>
            <Meta title="Change Phone" />
            <MainContainer>
                <AuthWrapper>
                    <EmailRecoveryForm />
                </AuthWrapper>
                <ForgetPasswordWrapper>
                    <StyledLink onClick={() => navigate("/profile")}>
                        Повернутись до профілю
                    </StyledLink>
                </ForgetPasswordWrapper>
            </MainContainer>
        </>
    );
};

export default ChangePhone;
